<app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="voie?.num" [label]="step5.getnum"
    [type]="'text'" [rule]="rule + 'minSize_1|maxSize_50'" [errorMessage]="errorMessage" [name]="getUid() + '_SepAtt_num'">
</app-form-input>
<app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="voie?.typevoie" [label]="step5.gettypevoie"
    [type]="'text'" [rule]="rule + 'minSize_1|maxSize_255'" [errorMessage]="errorMessage" [name]="getUid() + '_SepAtt_typevoie'">
</app-form-input>
<app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="voie?.nomvoie" [label]="step5.getnomvoie"
    [type]="'text'" [rule]="rule + 'minSize_5|maxSize_1000'" [errorMessage]="errorMessage" [name]="getUid() + '_SepAtt_nomvoie'">
</app-form-input>
